import './BankCard.sass';

import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { classNames } from '$utils';

import { mainActions } from '$store/main';
import { paymentMethodsActions, paymentMethodsSelector } from '$store/paymentMethods';

import { Card } from '$uikit';

import {
  IcBankCard56,
  IcCheck16,
  IcDelete24,
  IcMastercard56,
  IcMir56,
  IcVisa56,
} from '$assets';

import { BankCardProps } from './BankCard.interface';

export const BankCard: FC<BankCardProps> = ({
  type,
  cardId,
  cardNumber,
  isActive,
  isEdit,
  popup,
}) => {
  const dispatch = useDispatch();
  const { cards, isChangeCard } = useSelector(paymentMethodsSelector);

  const icon = useMemo(() => {
    const iconType = type.toUpperCase();

    switch (iconType) {
      case 'MASTERCARD':
        return <IcMastercard56 />;
      case 'VISA':
        return <IcVisa56 />;
      case 'MIR':
        return <IcMir56 />;
      default:
        return <IcBankCard56 />;
    }
  }, [type]);

  const handleRemoveCard = useCallback(() => {
    const card = cards?.find((item) => item.id === cardId);

    if (card) {
      dispatch(mainActions.setPopup(popup(card)));
    }
  }, [cardId]);

  const handleSelectCard = useCallback(() => {
    if (!isActive && !isChangeCard && !isEdit) {
      dispatch(paymentMethodsActions.setActiveCards({ id: cardId }));
    }
  }, [isActive, isChangeCard, isEdit]);

  function renderAfter() {
    if (isEdit) {
      return (
        <div className="BankCard__button_remove" onClick={() => handleRemoveCard()}>
          <IcDelete24 color="var(--foreground-tertiary)" />
        </div>
      );
    }

    return (
      <div
        className={classNames({
          BankCard__select: true,
          BankCard__select_active: isActive,
        })}
      >
        {isActive && <IcCheck16 />}
      </div>
    );
  }

  return (
    <Card
      className="BankCard"
      containerClassName="BankCard__container"
      before={icon}
      after={renderAfter()}
      title={`•••• ${cardNumber}`}
      onClick={() => handleSelectCard()}
    />
  );
};
